<template>
  <div class="params-on-chain-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="公司组织ID" prop="orgid">
            <!-- <el-input v-model="formDate.orgid" placeholder="请输入组织ID"></el-input> -->
            <el-select
              v-model="formDate.orgid"
              placeholder="请选择公司组织ID"
              clearable
              disabled
              class="auto-width"
            >
              <el-option
                v-for="item in orgOtion"
                :key="item.OrgId"
                :label="item.OrgName"
                :value="item.OrgId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="系统参数路径" prop="path">
            <el-input v-model="formDate.path" placeholder="请输入系统参数路径"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-button type="primary" @click="handleParamsOnchain()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  data() {
    return {
      formDate: {
        orgid: '',
        chainid: this.$route.query.chainId,
        path: ''
      },
      orgOtion: [],
      editRules: {
        path: [{ required: true, message: '请输入系统参数路径', trigger: 'blur' }],
        orgid: [{ required: true, message: '请选择公司组织ID', trigger: 'blur' }]
      },
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  mounted() {
    this.formDate.orgid = localStorage.getItem('orgid')
  },
  methods: {
    getOptions() {
      this.$apis.chain
        .getChainOrgList({ limit: 1000, offset: 0, chainId: this.$route.query.chainId })
        .then(res => {
          if (res.data && res.data.items) {
            let hasObj = {}
            this.orgOtion = res.data.items.reduce((result, cur) => {
              if (!hasObj[cur.OrgId]) {
                hasObj[cur.OrgId] = true
                result.push(cur)
              }
              return result
            }, [])
          }
        })
    },
    handleParamsOnchain() {
      this.$refs.formDate.validate(valid => {
        if (valid) {
          this.$apis.hibe.paramsOnchain(this.formDate).then(res => {
            if (res) {
              this.$message.success('上链成功!')
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.params-on-chain-wrapper {
  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}

</style>
